exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-39de4d54]{width:100%;border-collapse:collapse}.reportTbl td[data-v-39de4d54]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-39de4d54]{text-align:left;line-height:15px}.txtRight[data-v-39de4d54]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-39de4d54]{text-align:center}.reportTbl tr.tb-td td[data-v-39de4d54]{font-weight:700;text-align:center;border:none}td.textCenter[data-v-39de4d54]{text-align:center!important}td.textRight[data-v-39de4d54]{text-align:right!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39de4d54","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/pdf/designated_account_expense_contract2B.vue
// module id = 1656
// module chunks = 3